export const STATUS_CODES = {
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
};

export const API_ERRORS = {
  NO_RESPONSE: "NO_RESPONSE",
  REQUEST_SETUP_ERROR: "REQUEST_SETUP_ERROR",
};

export const ERROR_MESSAGES = {
  NO_RESPONSE_FROM_SERVER: "No response received from server",
  NETWORK_ERROR: "Network error occurred",
};

export const regionOptions = [
  {
    label: "APAC",
    value: "APAC",
  },
  {
    label: "Americas",
    value: "Americas",
  },
  {
    label: "Latin America",
    value: "Latin America",
  },
  {
    label: "EMEA",
    value: "EMEA",
  },
];

export const assessmentCategoryLabels = {
  short: "Short Assessment",
  long: "Long Assessment",
};
